// src/components/PageWrapper.jsx
import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export default function PageWrapper({ children, className = "" }) {
  const reduce = useReducedMotion();

  const variants = reduce
    ? {
        initial: { opacity: 1, y: 0, filter: "none" },
        enter:   { opacity: 1, y: 0, filter: "none", transition: { duration: 0 } },
        exit:    { opacity: 1, y: 0, filter: "none", transition: { duration: 0 } },
      }
    : {
        initial: { opacity: 0, y: 12, filter: "blur(4px)" },
        enter:   {
          opacity: 1, y: 0, filter: "blur(0px)",
          transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] }
        },
        exit:     {
          opacity: 0, y: -8, filter: "blur(4px)",
          transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] }
        },
      };

  return (
    <motion.div
      className={`min-h-[60vh] ${className}`}
      initial="initial"
      animate="enter"
      exit="exit"
      variants={variants}
    >
      {children}
    </motion.div>
  );
}
